import { render } from "./index.vue?vue&type=template&id=905b52de&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=905b52de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-905b52de"],['__file',"src/views/PrebookBanner/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "905b52de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('905b52de', __exports__)) {
    api.reload('905b52de', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=905b52de&scoped=true", () => {
    api.rerender('905b52de', render)
  })

}


export default __exports__